import React from "react";
import { Link } from "react-router-dom";

export default function Plans() {
  const plans = [
    {
      title: "1 Hour Access",
      description: "Instant access for 1 hour.",
      price: "15€",
      button: "Buy 1 Hour",
      bg: "bg-[#140D4F] text-white",
      planType: "1hour",
    },
    {
      title: "1 Day Access",
      description: "Full access for 24 hours.",
      price: "55€",
      button: "Buy 1 Day",
      bg: "bg-[#0267C1] text-white",
      planType: "1day",
    },
    {
      title: "1 Week Access",
      description: "Access for 7 days.",
      price: "205€",
      button: "Buy 1 Week",
      bg: "bg-[#B2D336] text-black",
      planType: "1week",
    },
    {
      title: "1 Month Access",
      description: "Access for 30 days.",
      price: "560€",
      button: "Buy 1 Month",
      bg: "bg-[#6C2BD9] text-white",
      planType: "1month",
    },
    {
      title: "1 Year Access",
      description: "Best value: 1 year full access.",
      price: "1900€",
      button: "Buy 1 Year",
      bg: "bg-[#FD5003] text-white",
      planType: "1year",
    },
  ];

  const startCheckout = async (planType) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/subscriptions/create-checkout-session?plan=${planType}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        alert("Could not start checkout. Please try again.");
      }
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Error connecting to payment gateway.");
    }
  };

  return (
    <div className="min-h-screen bg-white text-black py-16 px-4">
      <div className="max-w-5xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-10">Choose Your Plan</h1>
        <div className="flex flex-wrap justify-center gap-8">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`p-6 rounded-xl w-80 shadow-md ${plan.bg} flex flex-col justify-between`}
            >
              <div>
                <h2 className="text-2xl font-semibold mb-2">{plan.title}</h2>
                <p className={`text-sm mb-4 ${plan.bg.includes('text-black') ? 'text-black' : 'text-gray-200'}`}>{plan.description}</p>
                <p className="text-3xl font-bold mb-6">{plan.price}</p>
              </div>
              <button
                onClick={() => startCheckout(plan.planType)}
                className="mt-6 inline-block bg-white text-black font-semibold py-2 rounded hover:bg-gray-100 transition"
              >
                {plan.button}
              </button>
            </div>
          ))}
        </div>
        <div className="mt-12">
          <Link
            to="/chat"
            className="text-blue-600 hover:underline text-sm"
          >
            Already subscribed? Go to chat
          </Link>
        </div>
      </div>
    </div>
  );
}
